import {
  BulkJobAction,
  BulkProgressState,
  ProjectReportBulkJob,
} from 'organisms/CloudOpsReportAdmin/bulk/types';

export interface BulkActionPresentation {
  label: 'Approve' | 'Update';
  title: 'Bulk Approve' | 'Bulk Update';
  verb: 'approve' | 'update';
  noun: 'approval' | 'update';
  gerund: 'Approving' | 'Updating';
  past: 'approved' | 'updated';
}

const ACTION_PRESENTATION: Record<BulkJobAction, BulkActionPresentation> = {
  approve: {
    label: 'Approve',
    title: 'Bulk Approve',
    verb: 'approve',
    noun: 'approval',
    gerund: 'Approving',
    past: 'approved',
  },
  update: {
    label: 'Update',
    title: 'Bulk Update',
    verb: 'update',
    noun: 'update',
    gerund: 'Updating',
    past: 'updated',
  },
};

export const getBulkActionPresentation = (action: BulkJobAction) =>
  ACTION_PRESENTATION[action];

export const progressFromBulkJob = (
  job: ProjectReportBulkJob
): BulkProgressState => {
  const total = job.total_count || 0;
  const processed = job.processed_count || 0;
  const percentage = total ? Math.round((processed / total) * 100) : 0;
  const copy = getBulkActionPresentation(job.action);

  return {
    phase: job.action === 'approve' ? 'approving' : 'updating',
    severity: 'info',
    terminal: false,
    processed,
    total,
    message: `${copy.gerund} reports: ${processed} of ${total} completed (${percentage}%)`,
  };
};

export const resultFromBulkJob = (
  job: ProjectReportBulkJob
): BulkProgressState => {
  const failed = job.failed_count || 0;
  const skipped = job.skipped_count || 0;
  const clean = failed === 0 && skipped === 0;
  const copy = getBulkActionPresentation(job.action);
  let severity: BulkProgressState['severity'] = clean ? 'success' : 'warning';
  if (failed > 0) severity = 'error';

  return {
    phase: failed > 0 ? 'error' : 'completed',
    severity,
    terminal: true,
    message: clean
      ? `${job.succeeded_count} reports ${copy.past} successfully.`
      : `${job.succeeded_count} reports ${copy.past}, ${failed} failed, and ${skipped} skipped.`,
  };
};
